import { CallStatus, Groups, SelectMode } from '../../../models';
import { Settings } from '../../../variables';

export const KemUserGuideURL = Settings.ENV_EKSGUIDES_URL;
export const UnsecureExportEndDate = new Date('2023-02-15');
export const FileTypes = Object.freeze({
  CSV: 'CSV',
  KEM: 'KEM',
  KEM2: 'KEM2',
  //XML: 'XML',
  //OMS: 'OMS Raw',
  SIGFOX: 'SigFox',
});

export const FileTypesSearchable: { [key: string]: string } = FileTypes;

export const FileTypesList: string[] = Object.keys(FileTypes).map(
  (k) => FileTypesSearchable[k]
);

export interface View {
  groupedBy: Groups;
  mode: SelectMode;
}

export interface Data {
  keys: string[];
}

export type State = CallStatus & Data & View;

export type InitPL = View & Data;
export type SetModePL = View;
export type SetItemsPL = Data;
